module.exports = __webpack_public_path__ + "static/media/download-icon.14797578.svg";